import { compareStr } from '@/plugins/utils'

export default {
  contratConfigs: (state) => state.configs,
  contratConfigByYear: (state) => (annee) =>
    state.configs &&
    state.configs.find((model) => model && compareStr(model.getAnnee())(annee)),
  contratConfigs_pending: (state) => state.configs_pending
}
